import { Element } from "types/Data";

export function transformElementsListForLite(state: Element[]) {
	const list: Element[] = state
		.concat({
			key: `c105a902t28r0`,
			___parent: null,
			custom_наименование: "",
			custom_light: true,
			custom_used_in_pro: false,
			custom_для_сортировки: 15,
			custom_ед_изм: {
				label: ''
			},
			custom_источники: null,
			custom_влияние: null,
		})
		.filter((item) => item.custom_light);

	const formattedList = list.map((item) => {
		if (
			item.key === `c105a902t28r51554960` ||
			item.key === `c105a902t28r51554961`
		) {
			return {
				...item,
				___parent: {
					key: `c105a902t28r3620`,
				},
				custom_для_сортировки: 25,
			};
		}

		if (item.key === `c105a902t28r2038859`) {
			return {
				...item,
				___parent: {
					key: `c105a902t28r3620`,
				},
				custom_для_сортировки: 35,
			};
		}

		if (item.key === `c105a902t28r225`) {
			return {
				...item,
				___parent: {
					key: `c105a902t28r3620`,
				},
				custom_для_сортировки: 50,
			};
		}

		if (item.key === `c105a902t28r236`) {
			return {
				...item,
				___parent: {
					key: `c105a902t28r3620`,
				},
				custom_для_сортировки: 60,
			};
		}

		// Ликопин
		if (item.key === `c105a902t28r2038841`) {
			return {
				...item,
				___parent: {
					key: `c105a902t28r3701`,
				},
				custom_для_сортировки: 42,
			}
		}

		// Лютеин и зеаксантин
		if (item.key === `c105a902t28r2038842`) {
			return {
				...item,
				___parent: {
					key: `c105a902t28r3701`,
				},
				custom_для_сортировки: 42,
			}
		}

		const needChangeParent =
			item.___parent &&
			[`c105a902t28r221`, `c105a902t28r222`, `c105a902t28r223`, `c105a902t28r228`].includes(
				item.___parent.key
			);

		if (needChangeParent) {
			const indexes: { [key: string]: number } = {
				c105a902t28r12493202: 1,
				c105a902t28r12493207: 2,
				c105a902t28r12523083: 3,
				c105a902t28r12497601: 4,
				c105a902t28r12497603: 5,
				c105a902t28r12523027: 6,
				c105a902t28r12520074: 7,
				c105a902t28r3582: 10,
				c105a902t28r3583: 20,
				c105a902t28r2038901: 25,
				c105a902t28r228: 30,
				c105a902t28r2038895: 37,
				c105a902t28r2038909: 38,
				c105a902t28r2038913: 39,
				c105a902t28r231: 40,
				c105a902t28r233: 50,
				c105a902t28r11374694: 60,
			};

			return {
				...item,
				___parent: {
					key: 'c105a902t28r0'
				},
				custom_для_сортировки: indexes[item.key],
			};
		}

		return item;
	});

	return formattedList;
}